import incoming from './lists/incomingDSP';
import outgoing from './lists/outgoingDSP';

export default {
    namespaced: true,
    state: () => ({
        collection : "IncomingDSP",
        statuses: [
            { collection: "IncomingDSP", value: "0" },
            { collection: "OutgoingDSP", value: "All" },
        ],
        searches: [
            { collection: "IncomingDSP", value: null },
            { collection: "OutgoingDSP", value: null },
        ]
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        PUSH_STATUS (state, payload) {
            let exists = state.statuses.find(x => x.collection == payload.collection);

            if (exists) {
                exists.value = payload.value;
            }
            else {
                state.statuses.push(payload);
            }
        },
        PUSH_SEARCH (state, payload) {
            let exists = state.searches.find(x => x.collection == payload.collection);

            if (exists) {
                exists.value = payload.value;
            }
            else {
                state.searches.push(payload);
            }
        }
    },
    getters: {
        getCollection (state) {
            return state.collection;
        },
        getStatus (state) {
            return state.statuses.find(x => x.collection === state.collection)?.value ?? null;
        },
        getSearch (state) {
            return state.searches.find(x => x.collection === state.collection)?.value ?? null;
        }
    },
    modules: {
        incoming,
        outgoing
    }
}